import ControlsFiltersAuthors from './ControlsFiltersAuthors';
import { useUrlParams, useVerifications } from '../hooks';
import { ButtonFilterText } from '@/components/custom';
import { DateFilter } from '@/components/filters';
import { SortEnum } from '@/enums';

const ControlsFilters = () => {

  const { isLoadingVerifications } = useVerifications();
  const { sortType, date, setValue } = useUrlParams();

  const filterOrderValue = (
    sortType === SortEnum.ASC
      ? 'le plus ancien'
      : 'le plus récent'
  );

  const handleOnClickBtnResetSort = () =>
    setValue('sortType', SortEnum.DESC);

  const handleOnClickBtnSort = () =>
    setValue(
      'sortType',
      (
        sortType === SortEnum.ASC
          ? SortEnum.DESC
          : SortEnum.ASC
      )
    );

  return (
    <div className='flex flex-wrap items-end gap-3'>
      <DateFilter
        disabled={isLoadingVerifications}
        title='Sélectionner un jour'
        defaultValue={date}
        removable={false}
        paramName='date'
        text='Jour' />
      <ButtonFilterText
        onReset={handleOnClickBtnResetSort}
        disabled={isLoadingVerifications}
        onClick={handleOnClickBtnSort}
        title={`Ordre d'afficharge`}
        value={filterOrderValue}
        removable={false}
        text={`Ordre`} />
      <ControlsFiltersAuthors />
    </div>
  );

};

export default ControlsFilters;
